export interface Order {
  id: number;
  user_id: number;
  user_name: string;
  user_surname: string;
  management: string;
  office: string;
  total_amount: number;
  status: 'pending' | 'preparing' | 'on-the-way' | 'completed' | 'cancelled';
  ticket_used: number;
  created_at: string;
  updated_at: string;
  items?: OrderItem[];
  item_count?: number;
  items_summary?: string;
}

export type OrderLog = Order;

export interface OrderItem {
  id?: number;
  order_id?: number;
  product_id: number;
  name: string;
  quantity: number;
  price: number;
  size?: string;
  strength?: string;
  options?: Record<string, any>; // Yeni dinamik seçenekler
  created_at?: string;
}

export interface CreateOrderRequest {
  user_id: number;
  user_name: string;
  user_surname: string;
  management: string;
  office: string;
  total_amount: number;
  ticket_used: number;
  items: OrderItem[];
}

export interface UserOrderStats {
  total_orders: number;
  pending_orders: number;
  preparing_orders: number;
  on_the_way_orders: number;
  completed_orders: number;
  total_spent: number;
}

export interface OrderStats {
  totalOrders: number;
  todayOrders: number;
  pendingOrders: number;
  preparingOrders: number;
  totalRevenue: number;
}

export interface OrderSummary {
  id: number;
  user_id: number;
  total_amount: number;
  status: 'pending' | 'preparing' | 'on-the-way' | 'completed' | 'cancelled';
  created_at: string;
  item_count: number;
  items_summary: string;
}

export const OrderStatusLabels = {
  pending: 'Beklemede',
  preparing: 'Hazırlanıyor',
  'on-the-way': 'Yolda',
  completed: 'Tamamlandı',
  cancelled: 'İptal Edildi',
} as const;

export const OrderStatusColors = {
  pending: 'bg-yellow-100 text-yellow-800',
  preparing: 'bg-blue-100 text-blue-800',
  'on-the-way': 'bg-purple-100 text-purple-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
} as const;
